/* SV Tray Builder — Seery-Us Visionz
 * Visual "build your tray" mockup. Rules come from the Interchangeable Tray Guide:
 * every insert is 3" deep; widths S 1.75", M 2.5", MP 3", L 3.75".
 * A row is valid when its inserts are a sub-set of one of that system's allowed row combos.
 * "Extra trays" are loose inserts ordered on top of what fits inside (no fit limit).
 *
 * SvTrayBuilder.create(el, {
 *   system: 'truby', initial: { rows: [[{size,stone}]], extras: [{size,stone}] },
 *   extras: true,            // show the "Extra trays" section
 *   dp: false,               // diamond painting: hide stone sizes
 *   readonly: false,         // preview only (no palette / no clicks)
 *   priceFor: fn(item, where) -> cents | null,   where = 'tray' | 'extra'
 *   money: fn(cents) -> '$1.00',
 *   onChange: fn(state)
 * })
 */
(function () {
  'use strict';
  if (window.SvTrayBuilder) return;

  var SIZES = {
    S:  { name: 'Small',       short: 'S',  w: 1.75, stones: ['SS6', 'SS10', 'SS12'] },
    M:  { name: 'Medium',      short: 'M',  w: 2.5,  stones: ['SS10', 'SS12', 'SS20'] },
    MP: { name: 'Medium Plus', short: 'MP', w: 3.0,  stones: ['SS10', 'SS12', 'SS16', 'SS20'] },
    L:  { name: 'Large',       short: 'L',  w: 3.75, stones: ['SS10', 'SS10 Split', 'SS12', 'SS12 Split', 'SS16', 'SS20', 'SS30'] }
  };
  var DP_STONES = { S: ['SS10'], M: ['SS10'], MP: ['SS10'], L: ['SS10', 'SS10 Split'] };
  // Obie / Overton cases take Large trays only, in three styles: Full, Split and Flush w/ Tab.
  var OBIE_STONES = { L: ['SS10', 'SS12', 'SS16', 'SS20', 'SS30',
                          'SS10 Split', 'SS12 Split', 'SS16 Split', 'SS20 Split', 'SS30 Split',
                          'SS10 Flush w/ Tab', 'SS12 Flush w/ Tab', 'SS16 Flush w/ Tab', 'SS20 Flush w/ Tab', 'SS30 Flush w/ Tab'] };
  var OBIE_DP_STONES = { L: ['SS10', 'SS10 Split', 'SS10 Flush w/ Tab'] };
  var ORDER = ['S', 'M', 'MP', 'L'];

  // Allowed full-row combos per row type (from the tray guide)
  var ROW_TYPES = {
    betty:       { width: 8.75, combos: [['S','S','S','S','S'], ['L','M'], ['M','M','S'], ['MP','MP']] },
    bettyDouble: { width: 8.75, combos: [['S','S','S','S','S'], ['L','M'], ['M','M','S'], ['MP','MP'], ['L','S','S']] },
    wide:        { width: 10.5, combos: [['S','S','S','S','S','S'], ['L','L'], ['M','M','M'], ['L','M','S'], ['L','S','S','S'], ['M','M','S','S'], ['M','S','S','S','S'], ['MP','MP','S']] },
    large:       { width: 3.75, combos: [['L']] }
  };

  var SYSTEMS = {
    'betty-v2':        { name: 'Betty V2',        rowType: 'betty',       rows: 1,  rowLabel: 'Row' },
    'betty-v2-double': { name: 'Double Betty V2', rowType: 'bettyDouble', rows: 2,  rowLabel: 'Row' },
    'rose':            { name: 'Rose',            rowType: 'wide',        rows: 1,  rowLabel: 'Row' },
    'truby':           { name: 'Truby',           rowType: 'wide',        rows: 2,  rowLabel: 'Row' },
    'truby-xl':        { name: 'Truby XL',        rowType: 'wide',        rows: 3,  rowLabel: 'Row' },
    'blanche-xl':      { name: 'Blanche XL',      rowType: 'wide',        rows: 2,  rowLabel: 'Row' },
    'rue':             { name: 'Rue',             rowType: 'betty',       rows: 5,  rowLabel: 'Drawer' },
    'obie':            { name: 'Obie / Overton',  rowType: 'large',       rows: 10, rowLabel: 'Tray', stack: true, stones: OBIE_STONES, dpStones: OBIE_DP_STONES },
    'obie-xl':         { name: 'Obie XL',         rowType: 'large',       rows: 14, rowLabel: 'Tray', stack: true, stones: OBIE_STONES, dpStones: OBIE_DP_STONES }
  };

  function count(list) {
    var c = {};
    list.forEach(function (k) { c[k] = (c[k] || 0) + 1; });
    return c;
  }
  function fitsIn(items, combo) {
    var a = count(items), b = count(combo);
    for (var k in a) if ((b[k] || 0) < a[k]) return false;
    return true;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function bySize(a, b) { return SIZES[b.size].w - SIZES[a.size].w; }
  function copyItems(list) { return (list || []).map(function (it) { return { size: it.size, stone: it.stone }; }); }

  function TrayBuilder(root, opts) {
    if (root.__svtb) root.__svtb.destroy();
    root.__svtb = this;
    this.root = root;
    this.opts = opts || {};
    this.target = 'tray';
    this.setSystem(this.opts.system || 'blanche-xl', this.opts.initial);
  }

  TrayBuilder.prototype.setSystem = function (key, initial) {
    var sys = SYSTEMS[key];
    if (!sys) throw new Error('Unknown tray system: ' + key);
    this.key = key;
    this.sys = sys;
    this.type = ROW_TYPES[sys.rowType];
    this.sizesAllowed = ORDER.filter(function (k) {
      return this.type.combos.some(function (c) { return c.indexOf(k) > -1; });
    }, this);
    this.rows = [];
    for (var i = 0; i < sys.rows; i++) this.rows.push([]);
    this.extras = [];
    if (initial) {
      var rows = Array.isArray(initial) ? initial : initial.rows;
      (rows || []).forEach(function (r, i) { if (this.rows[i]) this.rows[i] = copyItems(r); }, this);
      if (!Array.isArray(initial) && this.opts.extras) this.extras = copyItems(initial.extras);
    }
    this.active = 0;
    for (var r = 0; r < this.rows.length; r++) { if (!this.isFull(r)) { this.active = r; break; } }
    this.render();
  };

  /* ---------- labels ---------- */
  TrayBuilder.prototype.stonesFor = function (size) {
    var sys = SYSTEMS[this.opts.system] || {};
    var over = this.opts.dp ? sys.dpStones : sys.stones;
    if (over && over[size]) return over[size];
    return this.opts.dp ? DP_STONES[size] : SIZES[size].stones;
  };
  TrayBuilder.prototype.stoneLabel = function (stone) {
    if (!this.opts.dp) return stone || '';
    if (/flush/i.test(stone || '')) return 'Flush w/ Tab';
    return /split/i.test(stone || '') ? 'Split' : '';
  };
  TrayBuilder.prototype.chipLabel = function (stone) {
    if (!this.opts.dp) return stone;
    if (/flush/i.test(stone)) return '+ Flush w/ Tab';
    return /split/i.test(stone) ? '+ Split' : '+ Add';
  };
  TrayBuilder.prototype.itemLabel = function (it) {
    var s = this.stoneLabel(it.stone);
    return SIZES[it.size].name + (s ? ' ' + s : '');
  };
  TrayBuilder.prototype.itemShort = function (it) {
    var s = this.stoneLabel(it.stone);
    return SIZES[it.size].short + (s ? ' ' + s : '');
  };
  TrayBuilder.prototype.money = function (c) {
    return typeof this.opts.money === 'function' ? this.opts.money(c) : '$' + (c / 100).toFixed(2);
  };
  TrayBuilder.prototype.price = function (it, where) {
    if (typeof this.opts.priceFor !== 'function') return null;
    var p = this.opts.priceFor(it, where);
    return p == null ? null : Number(p);
  };

  /* ---------- fit rules ---------- */
  TrayBuilder.prototype.rowSizes = function (i) { return this.rows[i].map(function (it) { return it.size; }); };
  TrayBuilder.prototype.canAdd = function (i, size) {
    var next = this.rowSizes(i).concat(size);
    return this.type.combos.some(function (c) { return fitsIn(next, c); });
  };
  TrayBuilder.prototype.addable = function (i) {
    return this.sizesAllowed.filter(function (k) { return this.canAdd(i, k); }, this);
  };
  TrayBuilder.prototype.isFull = function (i) { return this.rows[i].length > 0 && this.addable(i).length === 0; };
  TrayBuilder.prototype.isComplete = function () {
    for (var i = 0; i < this.rows.length; i++) if (!this.isFull(i)) return false;
    return true;
  };
  TrayBuilder.prototype.hasSet = function () { return this.opts.setPrice != null; };
  TrayBuilder.prototype.insertCount = function () { return this.rows.reduce(function (s, r) { return s + r.length; }, 0); };

  /* ---------- actions ---------- */
  TrayBuilder.prototype.add = function (size, stone) {
    if (this.target === 'extra') {
      this.extras.push({ size: size, stone: stone });
      this.extras.sort(bySize);
      this.update();
      return;
    }
    var i = this.active;
    if (!this.canAdd(i, size)) {
      this.flash(SIZES[size].name + ' won’t fit in ' + this.sys.rowLabel.toLowerCase() + ' ' + (i + 1) + ' with what’s already there.' +
        (this.opts.extras ? ' Switch to “Extra trays” to order it loose.' : ''));
      return;
    }
    this.rows[i].push({ size: size, stone: stone });
    this.rows[i].sort(bySize);
    this.lastPick = { size: size, stone: stone };
    if (this.isFull(i)) {
      for (var j = 1; j <= this.rows.length; j++) {
        var n = (i + j) % this.rows.length;
        if (!this.isFull(n)) { this.active = n; break; }
      }
    }
    this.update();
  };
  TrayBuilder.prototype.remove = function (i, idx) {
    this.rows[i].splice(idx, 1);
    this.active = i;
    this.target = 'tray';
    this.update();
  };
  TrayBuilder.prototype.removeExtra = function (size, stone) {
    for (var k = this.extras.length - 1; k >= 0; k--) {
      if (this.extras[k].size === size && this.extras[k].stone === stone) { this.extras.splice(k, 1); break; }
    }
    this.update();
  };
  // Stones we can actually sell for this size — a stone with no price is one we don't stock.
  TrayBuilder.prototype.availableStones = function (size, where) {
    var self = this;
    return this.stonesFor(size).filter(function (s) {
      if (typeof self.opts.priceFor !== 'function') return true;
      return self.price({ size: size, stone: s }, where || 'tray') !== null;
    });
  };

  // Fill every row that still has room with ONE size/stone. Rows already full are left alone,
  // so this tops up a part-built tray rather than replacing what's there.
  TrayBuilder.prototype.fillAll = function (size, stone) {
    if (!size) return;
    var added = 0;
    for (var i = 0; i < this.rows.length; i++) {
      while (this.canAdd(i, size)) { this.rows[i].push({ size: size, stone: stone }); added++; }
      this.rows[i].sort(bySize);
    }
    if (!added) {
      this.flash(SIZES[size].name + ' won’t fit anywhere else — every ' + this.sys.rowLabel.toLowerCase() + ' is full or too tight.');
      return;
    }
    this.lastPick = { size: size, stone: stone };
    this.flash('Added ' + added + ' × ' + this.itemShort({ size: size, stone: stone }) + '. Tap any insert to remove it.');
    this.update();
  };

  // Fill every row with a random mix of whatever still fits. Each pick is taken fresh from
  // what the row can still take, so the result is always a legal layout.
  TrayBuilder.prototype.fillRandom = function () {
    var self = this, added = 0;
    var pick = function (list) { return list[Math.floor(Math.random() * list.length)]; };
    for (var i = 0; i < this.rows.length; i++) {
      for (var guard = 0; guard < 60; guard++) {
        var fits = this.addable(i).filter(function (k) { return self.availableStones(k).length > 0; });
        if (!fits.length) break;
        var size = pick(fits);
        this.rows[i].push({ size: size, stone: pick(this.availableStones(size)) });
        added++;
      }
      this.rows[i].sort(bySize);
    }
    if (!added) {
      this.flash('Every ' + this.sys.rowLabel.toLowerCase() + ' is already full. “Start over” to shuffle again.');
      return;
    }
    this.flash('Filled ' + added + ' spot' + (added === 1 ? '' : 's') + ' at random. Tap any insert to swap it.');
    this.update();
  };

  // Kept for the old "fill the rest" button — fills with whatever was picked last.
  TrayBuilder.prototype.fillEmpty = function () {
    if (!this.lastPick) return;
    this.fillAll(this.lastPick.size, this.lastPick.stone);
  };
  TrayBuilder.prototype.clear = function (i) {
    if (i == null) { this.rows = this.rows.map(function () { return []; }); this.extras = []; this.active = 0; this.target = 'tray'; }
    else if (i === 'extra') this.extras = [];
    else this.rows[i] = [];
    this.update();
  };
  TrayBuilder.prototype.update = function () { this.render(); this.changed(); };

  /* ---------- output ---------- */
  TrayBuilder.prototype.group = function (items) {
    var self = this, map = {}, out = [];
    items.forEach(function (it) {
      var k = it.size + '|' + it.stone;
      if (!map[k]) { map[k] = { size: it.size, stone: it.stone, label: self.itemLabel(it), qty: 0 }; out.push(map[k]); }
      map[k].qty++;
    });
    out.sort(function (a, b) { return ORDER.indexOf(b.size) - ORDER.indexOf(a.size); });
    return out;
  };
  TrayBuilder.prototype.trayItems = function () { return [].concat.apply([], this.rows); };
  TrayBuilder.prototype.layoutText = function () {
    var self = this;
    return this.rows.map(function (r, i) {
      var parts = r.map(function (it) { return self.itemShort(it); });
      return self.sys.rowLabel + ' ' + (i + 1) + ': ' + (parts.length ? parts.join(' + ') : 'empty');
    }).join(' | ');
  };
  TrayBuilder.prototype.extrasText = function () {
    return this.group(this.extras).map(function (g) { return g.qty + ' x ' + g.label; }).join(', ');
  };
  TrayBuilder.prototype.cost = function () {
    var self = this, total = 0;
    this.trayItems().forEach(function (it) { total += self.price(it, 'tray') || 0; });
    this.extras.forEach(function (it) { total += self.price(it, 'extra') || 0; });
    if (this.hasSet() && this.isComplete()) total += Number(this.opts.setPrice) || 0;
    return total;
  };
  TrayBuilder.prototype.state = function () {
    return {
      system: this.key,
      rows: this.rows.map(copyItems),
      extras: copyItems(this.extras),
      layout: this.layoutText(),
      extrasText: this.extrasText(),
      inserts: this.insertCount(),
      complete: this.isComplete(),
      cost: this.cost()
    };
  };
  TrayBuilder.prototype.changed = function () {
    if (typeof this.opts.onChange === 'function') this.opts.onChange(this.state());
  };

  TrayBuilder.prototype.flash = function (msg) {
    var el = this.root.querySelector('.svtb-flash');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(this._ft);
    this._ft = setTimeout(function () { el.hidden = true; }, 3200);
  };

  TrayBuilder.prototype.rowStatus = function (i) {
    var r = this.rows[i];
    if (!r.length) return { cls: 'empty', text: this.opts.readonly ? 'Empty' : 'Empty — tap a size below' };
    if (this.isFull(i)) return { cls: 'full', text: 'Full' };
    var names = this.addable(i).map(function (k) { return SIZES[k].name; });
    return { cls: 'room', text: 'Room for: ' + names.join(', ') };
  };

  /* ---------- render ---------- */
  TrayBuilder.prototype.renderInsert = function (it, attrs, widthPct) {
    var z = SIZES[it.size], s = this.stoneLabel(it.stone), ro = this.opts.readonly;
    var tag = ro ? 'span' : 'button type="button"';
    return '<' + tag + ' class="svtb-insert svtb-insert--' + it.size.toLowerCase() + '"' +
      (widthPct != null ? ' style="width:' + widthPct + '%"' : '') + (ro ? '' : ' ' + attrs + ' aria-label="Remove ' + esc(this.itemLabel(it)) + '"') + '>' +
      '<span class="svtb-insert__size">' + esc(z.short) + '</span>' +
      (s ? '<span class="svtb-insert__stone">' + esc(s) + '</span>' : '') +
      (ro ? '' : '<span class="svtb-insert__x" aria-hidden="true">×</span>') +
      '</' + (ro ? 'span' : 'button') + '>';
  };

  TrayBuilder.prototype.render = function () {
    var self = this, sys = this.sys, type = this.type, ro = !!this.opts.readonly;
    var h = '';
    var trayCls = sys.stack ? ' svtb-tray--stack' : (sys.rows >= 3 ? ' svtb-tray--compact' : '');
    h += '<div class="svtb-tray' + trayCls + (ro ? ' svtb-tray--ro' : '') + (this.target === 'extra' ? ' is-dim' : '') + '"' +
      (sys.stack ? ' style="--stack-rows:' + Math.ceil(sys.rows / 2) + '"' : '') + ' role="group" aria-label="' + esc(sys.name) + ' layout">';
    this.rows.forEach(function (r, i) {
      var st = self.rowStatus(i);
      var used = r.reduce(function (s, it) { return s + SIZES[it.size].w; }, 0);
      var scale = st.cls === 'full' ? used : type.width; // a full row fills the bed
      var active = !ro && self.target === 'tray' && i === self.active;
      h += '<div class="svtb-row' + (active ? ' is-active' : '') + ' svtb-row--' + st.cls + '">';
      h += ro ? '<div class="svtb-row__head">' : '<button type="button" class="svtb-row__head" data-act="row" data-row="' + i + '" aria-pressed="' + active + '">';
      h += '<span class="svtb-row__name">' + esc(sys.rowLabel) + ' ' + (i + 1) + '</span>';
      if (!sys.stack) h += '<span class="svtb-row__status">' + esc(st.text) + '</span>';
      h += ro ? '</div>' : '</button>';
      h += '<div class="svtb-row__bed"' + (ro ? '' : ' data-act="row" data-row="' + i + '"') + ' style="--row-w:' + type.width + '">';
      r.forEach(function (it, idx) {
        h += self.renderInsert(it, 'data-act="remove" data-row="' + i + '" data-idx="' + idx + '"', SIZES[it.size].w / scale * 100);
      });
      var free = st.cls === 'full' ? 0 : Math.max(0, type.width - used);
      if (free > 0.01) h += '<span class="svtb-free" style="width:' + (free / type.width * 100) + '%"></span>';
      h += '</div></div>';
    });
    h += '</div>';

    // extra trays (loose)
    if (this.opts.extras && (!ro || this.extras.length)) {
      var groups = this.group(this.extras);
      var xActive = !ro && this.target === 'extra';
      h += '<div class="svtb-extras' + (xActive ? ' is-active' : '') + '">';
      h += ro ? '<div class="svtb-row__head">' : '<button type="button" class="svtb-row__head" data-act="target" data-target="extra" aria-pressed="' + xActive + '">';
      h += '<span class="svtb-row__name">Extra trays</span><span class="svtb-row__status">' +
        (groups.length ? this.extras.length + ' loose' : (ro ? '' : 'Optional — order more to swap in')) + '</span>';
      h += ro ? '</div>' : '</button>';
      h += '<div class="svtb-extras__bed"' + (ro ? '' : ' data-act="target" data-target="extra"') + '>';
      groups.forEach(function (g) {
        var tile = self.renderInsert(g, 'data-act="remove-extra" data-size="' + g.size + '" data-stone="' + esc(g.stone) + '"', null);
        h += '<span class="svtb-extra svtb-extra--' + g.size.toLowerCase() + '">' + tile + (g.qty > 1 ? '<span class="svtb-extra__qty">×' + g.qty + '</span>' : '') + '</span>';
      });
      if (!groups.length && !ro) h += '<span class="svtb-extras__empty">Tap here, then add sizes — no fit limit.</span>';
      h += '</div></div>';
    }

    if (!ro) {
      // palette
      var inExtra = this.target === 'extra';
      var addable = inExtra ? this.sizesAllowed : this.addable(this.active);
      var sizes = inExtra ? ORDER.filter(function (k) { return self.sizesAllowed.indexOf(k) > -1 || !sys.stack; }) : this.sizesAllowed;
      h += '<div class="svtb-palette">';
      if (this.opts.extras) {
        h += '<div class="svtb-target" role="tablist">' +
          '<button type="button" role="tab" data-act="target" data-target="tray" aria-selected="' + !inExtra + '">Inside The Case</button>' +
          '<button type="button" role="tab" data-act="target" data-target="extra" aria-selected="' + inExtra + '">Extra trays</button></div>';
      }
      h += '<div class="svtb-palette__title">' + (inExtra ? 'Add <strong>extra trays</strong> (loose)' : 'Add to <strong>' + esc(sys.rowLabel) + ' ' + (this.active + 1) + '</strong>') + '</div>';
      sizes.forEach(function (k) {
        var z = SIZES[k], ok = inExtra || addable.indexOf(k) > -1;
        var sample = { size: k, stone: self.stonesFor(k)[0] };
        var p = self.price(sample, inExtra ? 'extra' : 'tray');
        h += '<div class="svtb-size' + (ok ? '' : ' is-off') + '">';
        h += '<div class="svtb-size__label"><span class="svtb-swatch svtb-insert--' + k.toLowerCase() + '"></span>' + esc(z.name) +
          ' <span class="svtb-dim">' + z.w + '" × 3"</span>' +
          (p ? '<span class="svtb-price">+' + esc(self.money(p)) + '</span>' : (p === 0 ? '<span class="svtb-price svtb-price--inc">Included</span>' : '')) +
          (ok ? '' : '<span class="svtb-nofit">won’t fit</span>') + '</div>';
        h += '<div class="svtb-chips">';
        var lp = self.lastPick;
        var chip = function (s, label) {
          var avail = self.price({ size: k, stone: s }, inExtra ? 'extra' : 'tray') !== null || typeof self.opts.priceFor !== 'function';
          var on = ok && avail;
          // The chip you tapped last stays lit, so it's obvious what "Fill all" will use.
          var picked = !inExtra && lp && lp.size === k && lp.stone === s;
          return '<button type="button" class="svtb-chip' + (picked ? ' is-picked' : '') + '" data-act="add" data-size="' + k +
            '" data-stone="' + esc(s) + '" aria-pressed="' + (picked ? 'true' : 'false') + '"' + (on ? '' : ' disabled') + '>' +
            esc(label) + '</button>';
        };
        var stones = self.stonesFor(k);
        var flushes = stones.filter(function (s) { return /flush/i.test(s); });
        var splits = stones.filter(function (s) { return /split/i.test(s) && !/flush/i.test(s); });
        if (k === 'L' && (splits.length || flushes.length)) {
          // Large: group as Full / Split / Flush w/ Tab
          var fulls = stones.filter(function (s) { return !/split|flush/i.test(s); });
          if (self.opts.dp) {
            h += chip(fulls[0], 'Full');
            if (splits.length) h += chip(splits[0], 'Split');
            if (flushes.length) h += chip(flushes[0], 'Flush w/ Tab');
          } else {
            var group = function (label, list, strip) {
              if (!list.length) return '';
              return '<div class="svtb-subgroup"><span class="svtb-subgroup__label">' + label + '</span><div class="svtb-chips">' +
                list.map(function (s) { return chip(s, strip ? s.replace(strip, '').trim() : s); }).join('') + '</div></div>';
            };
            h += '</div>' +
              group('Full', fulls, null) +
              group('Split', splits, /\s*split/i) +
              group('Flush w/ Tab', flushes, /\s*flush\s*w\/?\s*tab/i) +
              '<div>';
          }
        } else {
          stones.forEach(function (s) { h += chip(s, self.chipLabel(s)); });
        }
        // Fills every remaining spot with THIS size — using the chip they just tapped when it
        // belongs to this size, otherwise the first one we stock. Label stays short; the full
        // wording lives in the tooltip and the screen-reader label.
        if (ok && !inExtra) {
          var fillStone = (lp && lp.size === k) ? lp.stone : self.availableStones(k)[0];
          if (fillStone) {
            var full = 'Fill all with ' + self.itemLabel({ size: k, stone: fillStone });
            h += '<button type="button" class="svtb-link svtb-fillsize" data-act="fill-size" data-size="' + k +
              '" data-stone="' + esc(fillStone) + '" title="' + esc(full) + '" aria-label="' + esc(full) + '">Fill all</button>';
          }
        }
        h += '</div></div>';
      });
      h += '<div class="svtb-flash" role="status" hidden></div>';
      h += '<div class="svtb-tools">';
      h += inExtra ? '<button type="button" class="svtb-link" data-act="clear-extra">Clear extra trays</button>'
        : '<button type="button" class="svtb-link" data-act="clear-row">Clear ' + esc(sys.rowLabel.toLowerCase()) + ' ' + (this.active + 1) + '</button>';
      if (!inExtra && !this.isComplete()) {
        h += '<button type="button" class="svtb-link svtb-link--strong" data-act="fill-random"' +
          ' title="Fill every empty spot with a random mix">Random fill</button>';
      }
      h += '<button type="button" class="svtb-link" data-act="clear-all">Start over</button>';
      h += '</div></div>';

      // summary
      var tray = this.group(this.trayItems()), extra = this.group(this.extras);
      var line = function (g, where) {
        var p = self.price(g, where);
        var right = p ? self.money(p * g.qty) : (p === 0 ? 'Included' : '');
        return '<li><span>' + g.qty + ' × ' + esc(g.label) + '</span><span>' + esc(right) + '</span></li>';
      };
      h += '<div class="svtb-summary"><div class="svtb-summary__title">Your inserts</div>';
      if (this.hasSet()) {
        var n = this.rows.length, filled = this.rows.filter(function (r) { return r.length; }).length;
        var sp = '+' + this.money(Number(this.opts.setPrice) || 0);
        h += '<div class="svtb-set' + (this.isComplete() ? ' is-done' : '') + '">' +
          (this.isComplete() ? '\u2713 Full set of ' + n + ' trays <strong>' + esc(sp) + '</strong>'
            : (filled ? filled + ' of ' + n + ' trays picked \u2014 fill all ' + n + ' for the full set (' + esc(sp) + '), or clear them for case only.'
              : 'Case only. Fill all ' + n + ' trays to get the full set for ' + esc(sp) + '.')) + '</div>';
      }
      if (!tray.length && !extra.length) h += '<div class="svtb-dim">Nothing added yet.</div>';
      else {
        h += '<ul>';
        tray.forEach(function (g) { h += line(g, 'tray'); });
        if (extra.length) {
          h += '<li class="svtb-summary__sub"><span>Extra trays</span><span></span></li>';
          extra.forEach(function (g) { h += line(g, 'extra'); });
        }
        var c = this.cost();
        if (c) h += '<li class="svtb-summary__total"><span>Inserts total</span><span>+' + esc(this.money(c)) + '</span></li>';
        h += '</ul>';
      }
      h += '</div>';
    }

    this.root.classList.add('svtb');
    this.root.classList.toggle('svtb--ro', ro);
    var tint = this.opts.tint;
    this.root.classList.toggle('svtb--tinted', !!(tint && tint.bg));
    if (tint && tint.bg) { this.root.style.setProperty('--svtb-tint', tint.bg); this.root.style.setProperty('--svtb-tint-fg', tint.fg || '#1f2328'); }
    this.root.innerHTML = h;
    if (!ro) this.bind();
  };

  TrayBuilder.prototype.bind = function () {
    var self = this;
    if (this._bound) return;
    this._bound = true;
    this._onClick = function (e) {
      var t = e.target.closest('[data-act]');
      if (!t || !self.root.contains(t)) return;
      e.preventDefault();
      var act = t.getAttribute('data-act');
      if (act === 'add') self.add(t.getAttribute('data-size'), t.getAttribute('data-stone'));
      else if (act === 'remove') { e.stopPropagation(); self.remove(+t.getAttribute('data-row'), +t.getAttribute('data-idx')); }
      else if (act === 'remove-extra') { e.stopPropagation(); self.removeExtra(t.getAttribute('data-size'), t.getAttribute('data-stone')); }
      else if (act === 'row') { self.target = 'tray'; self.active = +t.getAttribute('data-row'); self.render(); }
      else if (act === 'target') { self.target = t.getAttribute('data-target'); self.render(); }
      else if (act === 'clear-row') self.clear(self.active);
      else if (act === 'clear-extra') self.clear('extra');
      else if (act === 'clear-all') self.clear();
      else if (act === 'fill-empty') self.fillEmpty();
      else if (act === 'fill-size') self.fillAll(t.getAttribute('data-size'), t.getAttribute('data-stone'));
      else if (act === 'fill-random') self.fillRandom();
    };
    this.root.addEventListener('click', this._onClick);
  };
  TrayBuilder.prototype.destroy = function () {
    if (this._onClick) this.root.removeEventListener('click', this._onClick);
    this._bound = false;
    if (this.root.__svtb === this) this.root.__svtb = null;
  };

  window.SvTrayBuilder = {
    create: function (el, opts) { return new TrayBuilder(el, opts); },
    SYSTEMS: SYSTEMS, SIZES: SIZES, ROW_TYPES: ROW_TYPES, DP_STONES: DP_STONES
  };
})();
